import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";


export function Navbar({ onSearch, profileName = 'Usuário', avatarUrl }) {


  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();



  function handleLogout(){


    localStorage.removeItem("usuario");
    localStorage.removeItem("token");


    navigate("/login");

  }



  return (

    <header 
      className="
        h-18 
        bg-white 
        border-b 
        border-border 
        px-8 
        flex 
        items-center 
        justify-between 
        font-body 
        sticky 
        top-0 
        z-30
      "
    >


      {/* Search Input */}

      <div className="w-80 relative flex items-center">


        <span className="absolute left-3.5 text-text-secondary/60">

          <svg 
            className="w-4 h-4" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            viewBox="0 0 24 24"
          >

            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
            />

          </svg>

        </span>


        <input

          type="search"

          placeholder="Pesquisar..."

          onChange={(e)=>onSearch?.(e.target.value)}

          className="
            w-full
            bg-background/50
            border
            border-border
            pl-10
            pr-4
            py-2
            text-small
            rounded-input
            focus:outline-none
            focus:ring-2
            focus:ring-primary/20
            focus:border-primary
          "

        />


      </div>





      {/* Right Side */}

      <div className="flex items-center gap-6">


        {/* Ajuda */}

        <button

          title="Ajuda"

          className="
            text-text-secondary
            hover:text-text-primary
            p-1.5
            hover:bg-background
            rounded-button
          "

        >

          ?

        </button>





        {/* Notificações */}

        <button

          title="Notificações"

          className="
            text-text-secondary
            hover:text-text-primary
            p-1.5
            hover:bg-background
            rounded-button
            relative
          "

        >

          🔔


          <span
            className="
              absolute
              top-1.5
              right-1.5
              w-2
              h-2
              bg-danger
              rounded-full
            "
          />

        </button>





        <div className="w-px h-6 bg-border" />





        {/* Menu Usuário */}

        <div className="relative">


          <button

            onClick={()=>setMenuOpen(!menuOpen)}

            className="
              flex
              items-center
              gap-3
              hover:bg-background
              p-2
              rounded-button
            "

          >


            <div className="text-right hidden sm:block">


              <p className="
                text-small
                font-semibold
                text-text-primary
              ">

                {profileName}

              </p>


              <p className="
                text-caption
                text-text-secondary
              ">

                Empreendedor

              </p>


            </div>




            {
              avatarUrl ? (

                <img

                  src={avatarUrl}

                  alt={profileName}

                  className="
                    w-10
                    h-10
                    rounded-full
                    object-cover
                    border
                    border-border
                  "

                />

              ) : (

                <div

                  className="
                    w-10
                    h-10
                    rounded-full
                    bg-accent
                    text-primary
                    flex
                    items-center
                    justify-center
                    font-semibold
                    border
                    border-border
                  "

                >

                  {
                    profileName
                    .slice(0,2)
                    .toUpperCase()
                  }

                </div>

              )

            }



            <span className="text-text-secondary">
              ▾
            </span>



          </button>






          {
            menuOpen && (


              <div

                className="
                  absolute
                  right-0
                  mt-2
                  w-52
                  bg-white
                  border
                  border-border
                  rounded-card
                  shadow-lg
                  p-2
                  z-50
                "

              >



                <Link

                  to="/configuracoes"

                  onClick={()=>setMenuOpen(false)}

                  className="
                    block
                    px-4
                    py-2
                    text-small
                    rounded-button
                    hover:bg-background
                  "

                >

                  Minha conta

                </Link>





                <button

                  onClick={handleLogout}

                  className="
                    w-full
                    text-left
                    px-4
                    py-2
                    text-small
                    rounded-button
                    hover:bg-background
                    text-danger
                  "

                >

                  Sair

                </button>



              </div>


            )

          }



        </div>



      </div>



    </header>

  );

}